<!--助力分享-->
<!--仅仅完成简单的分享&助力功能-->
<!--需要绑定活动Id 以获取分享码-->
<template>
  <ModalCommon ref="ModalCommon" :title="config.title">
    <div class="wrap">
      <div class="content">
        <div class="link-wrap">
          <input placeholder="请输入code" size="mini" v-model="code" class="normal-input" />
          <div class="line"></div>
          <div class="btn-share hv-highlight flex-shrink-0" @click="joinFunc">加入</div>
        </div>
      </div>
    </div>
  </ModalCommon>
</template>

<script>
import { copyContent } from '../utils'
import ModalCommon from './ModalCommon'
export default {
  name: 'ModalShare',
  components: {
    ModalCommon
  },
  props: {
  },
  data() {
    return {
      visible: false,
      activityId: '',
      code: '',
      config: {
        title: '加入队伍'
      }
    }
  },
  inject: {
    $MainWrap: {
      default: null
    },
    eventBus: {
      default: null
    }
  },
  computed: {
    requestAPI() {
      return this.request ? this.request : window.$request
    }
  },
  async mounted() {
  },
  methods: {
    async open(options) {
      if (!window.$checkLogin()) return
      this.activityId = options.activityId
      this.$refs.ModalCommon.open()
    },
    joinFunc() {
      console.log(1)
      if (!window.$checkLogin()) return
      if (this.code) {
        return this.requestAPI({
          url: '/v1/uni/official/team-join',
          method: 'get',
          params: {
            a_id: this.activityId,
            code: this.code
          }
        }).then(() => {
          this.$message.success('操作成功')
          this.$emit('joinSuccess')
          this.code = ''
          this.$refs.ModalCommon.close()
        }).catch(err => {
          console.error(err)
          this.code = ''
          this.$message.error(err.msg || '系统错误')
          this.$refs.ModalCommon.close()
        })
      }
    }
  },
  beforeDestroy() {
  }
}
</script>

<style scoped lang="scss">
.wrap {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.normal-input {
  width: 100%;
  height: 40px;
  padding: 0 10px;
  border: 1px solid #ccc;
  outline: none;
  box-sizing: border-box;
  border: none;
  background-color: transparent;
  font-size: 28px;
  color:#fff;
}

.content {
  flex: 1;
  display: flex;
  justify-content: center;
  flex-direction: column;
  height: 100%;
  padding: 0 60px 100px;

  .sub-title {
    text-align: center;
    margin-bottom: 40px;
    font-size: 30px;
  }

  .link-wrap {
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: rgba(0, 0, 0, .6);
    border-radius: 4px;

    p {
      flex: 1;
      height: 65px;
      line-height: 65px;
      padding: 0 20px;
      color: #fff;
      //background-image: url("../../../assets/images/fungus/link_bg.png");
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      letter-spacing: normal;
      font-size: 20px;
    }

    .line {
      width: 1px;
      height: 40px;
      background-color: #fff;
    }

    .btn-share {
      margin-left: 10px;
      width: 177px;
      font-size: 27px;
      height: 73px;
      line-height: 73px;
      text-align: center;
      color: #eee;

      &:hover {
        color: #fff;
      }
    }
  }
}
</style>
